import { z } from 'zod';

export const coverageAreaZ = z.object({
  _id: z.string().optional(),
  zipCode: z
    .string()
    .min(5, 'Zip code must be at least 5 characters')
    .max(10, 'Zip code must be at most 10 characters'),
  city: z.string().min(1, 'City is required').max(100, 'City must be at most 100 characters'),
  state: z
    .string()
    .min(2, 'State must be at least 2 characters')
    .max(50, 'State must be at most 50 characters'),
  active: z.boolean().default(true),
  organizationId: z.string().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type CoverageAreaZ = z.infer<typeof coverageAreaZ>;
